import { ErrorNotificationIcon } from "@/assets/icons";
import { useToast } from "@/store/useToast";
import { Trans } from "react-i18next";

export const showDeleteLastPhotoToast = () => {
    const showToast = useToast((state) => state.show);
    showToast({
        icon: <ErrorNotificationIcon />,
        msg: <Trans i18nKey="delete_last_photo_error" />
    })
}
